import type { IconData } from '@stacksjs/iconify-core'

export const clipboard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M432 56h-56v32h48v376H88V88h48V56H80a24.03 24.03 0 0 0-24 24v392a24.03 24.03 0 0 0 24 24h352a24.03 24.03 0 0 0 24-24V80a24.03 24.03 0 0 0-24-24\"/><path fill=\"currentColor\" d=\"M192 140h128a24.03 24.03 0 0 0 24-24V16H168v100a24.03 24.03 0 0 0 24 24m8-92h112v60H200Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default clipboard
